import WebRTC from './components/WebRTC';
import './App.css';

function App() {
  return <WebRTC />;
}

export default App;
